import React from 'react';
import { useSelector } from 'react-redux';

import { FMColumn } from '../../model';

import { FileManagerRow } from '../../model';
import { getBlLoading } from '../../selectors/selectors';

import './styles.scss';

export const Inner: React.FC<{
  rowData: FileManagerRow;
  column: FMColumn<any>;
  cellData: any;
  component: React.FC<{
    cellData: any;
    rowData: FileManagerRow;
    column: FMColumn<any>;
  }>;
}> = (props) => {
  const { rowData, column, component, cellData } = props;
  const loading = useSelector(getBlLoading);
  if (loading) {
    // Плашка-заглушка, а не спиннер: этих ячеек на экране под сотню (шесть
    // колонок бизнес-данных на каждую видимую строку), и таблица из крутящихся
    // спиннеров читается как поломка. Полоска же просто показывает, что на
    // месте значения скоро что-то будет.
    return <span className="ch-cell-loading" role="presentation" />;
  }
  const C = component;
  return <C cellData={cellData} rowData={rowData} column={column} />;
};

export const WithLoader =
  (
    component: React.FC<{
      rowData: FileManagerRow;
      cellData: any;
      column: FMColumn<any>;
    }>,
  ) =>
  (props: any) => <Inner component={component} {...props} />;
